import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/support`;
const getMessageOverviewEndpoint = (externalReference) => `${getEndpoint()}/message-overview/${externalReference}`;
const getViewMessagesEndpoint = (programmeExternalReference, systemUserExternalReference, page, size) =>
  `${getEndpoint()}/view/message/${programmeExternalReference}/${systemUserExternalReference}/${page}/${size}`;

export const getViewMessageOverviewRequest = (programmeExternalReference) => [
  getMessageOverviewEndpoint(programmeExternalReference),
  getHttpGetOptions()
];

export const getViewMessagesRequest = (programmeExternalReference, systemUserExternalReference, page, size) => [
  getViewMessagesEndpoint(programmeExternalReference, systemUserExternalReference, page, size),
  getHttpGetOptions()
];

export const getCreateMessageRequest = (message) => [getEndpoint(), getHttpPostOptions(message)];

export const getDeleteMessageRequest = (programmeExternalReference, systemUserExternalReference) => [
  `${getEndpoint()}/delete/message/${programmeExternalReference}/${systemUserExternalReference}`,
  getHttpGetOptions()
];
